import { statusLabel } from '../lib/format.js';

const TONE_CLASSES: Record<'ok' | 'warn' | 'error' | 'muted', string> = {
  ok: 'text-ok bg-ok-soft ring-ok/20',
  warn: 'text-warn bg-warn-soft ring-warn/20',
  error: 'text-danger bg-danger-soft ring-danger/20',
  muted: 'text-muted bg-surface-2 ring-line',
};

const DOT_CLASSES: Record<'ok' | 'warn' | 'error' | 'muted', string> = {
  ok: 'bg-ok',
  warn: 'bg-warn',
  error: 'bg-danger',
  muted: 'bg-faint',
};

export function StatusBadge({ status }: { status: string }) {
  const { label, tone } = statusLabel(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium ring-1 ring-inset ${TONE_CLASSES[tone]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${DOT_CLASSES[tone]}`} aria-hidden />
      {label}
    </span>
  );
}
